const formatCertificateName = (domainName: string, hostedZoneName: string, certType: string): string => {
  // Default certificate name template
  let finalCertificateName: string = `${domainName}.${hostedZoneName}`

  // Set finalCertificateName to only the hostedZoneName
  // if certType is 'domain' and domainName is blank
  if (certType === 'domain' && domainName.length === 0) {
    finalCertificateName = hostedZoneName
  }

  return finalCertificateName
}

export default formatCertificateName
